export default "__VITE_ASSET__b090e857__"